import { visuallyHiddenStyle } from './vinExtractionStyles';

/** "—" for a missing value, with what is missing spelled out for screen readers. */
const NoValue = ({ label }) => (
    <>
        <span aria-hidden="true">—</span>
        <span style={visuallyHiddenStyle}>{label}</span>
    </>
);

export default NoValue;
